import { Box, Typography } from '@mui/material'

function Favorites() {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100%' }}>
      <Typography>Favorites Page</Typography>
    </Box>
  )
}

export default Favorites
